import { connect } from 'react-redux';
import { closeNotification } from '../reducers/notification.reducers';
import Notification from './notification';

const mapStateToProps = state => ({
  open: state.notification.show,
  message: state.notification.message,
  errorMessage: state.notification.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  onCloseNotification: () => dispatch(closeNotification()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
